'use client';

import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { getAccountKey, useAccount } from '@air/utils-auth';

/**
 * Plugin counterpart of core `useIsCurrentUserEmailVerified`.
 * Reads Air `account.emailVerified` (not Cognito `email_verified`) and exposes a
 * refresh that invalidates the cached account so the verify-user surface can
 * re-check after the user clicks the email link in the web app (a different
 * origin, so a BroadcastChannel would not fire).
 */
export const useIsUserVerified = () => {
  const { data: account, isFetched, isRefetching } = useAccount();
  const queryClient = useQueryClient();
  const userEmail = account?.email;
  const userEmailIsVerified = account?.emailVerified;

  const refreshUserVerification = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: getAccountKey() });
  }, [queryClient]);

  return {
    isFetched,
    isRefreshing: isRefetching,
    refreshUserVerification,
    userEmail,
    userEmailIsVerified,
  };
};
